@if (updateInProgress()) {
  <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
}
<div class="board-wrapper">
  @if (showCarousel()) {
    <div class="carousel-container">
      <mat-icon class="carousel-header-button" (click)="previousColumn()">keyboard_arrow_left</mat-icon>
      <div class="carousel-nav">
        @for (navItem of columnNavItems(); track $index) {
          <div
            class="carousel-nav-item"
            [class.active]="navItem.active"
            (click)="scrollColumnIntoView(navItem.id)"
          ></div>
        }
      </div>
      <mat-icon class="carousel-header-button" (click)="nextColumn()">keyboard_arrow_right</mat-icon>
    </div>
  }
  <div
    class="board-container"
    [class.mobile]="mobileBreakpoint()"
    cdkDropListGroup
    [cdkDropListGroupDisabled]="updateInProgress() || mobileBreakpoint()"
  >
    @for (column of columns(); track column) {
      <crm-board-column
        class="column-container"
        [class.mobile]="mobileBreakpoint()"
        [attr.data-column-id]="column.id"
        [column]="column"
        [datasource]="datasource"
        [headerTemplate]="$safeNavigationMigration(columnHeader?.templateRef)"
        [cardTemplate]="$safeNavigationMigration(cardContent?.templateRef)"
        (itemDropped)="onItemDropped($event)"
        (itemEntered)="scrollColumnIntoView(column.id)"
        (itemClicked)="onItemClicked($event)"
        (columnVisible)="onColumnVisible(column.id)"
        (columnHidden)="onColumnHidden(column.id)"
      ></crm-board-column>
    }
  </div>
</div>
